import { render, staticRenderFns } from "./AllVisitableCustomersModalFrameSubComponent.vue?vue&type=template&id=12499640&scoped=true&"
import script from "./AllVisitableCustomersModalFrameSubComponent.vue?vue&type=script&lang=js&"
export * from "./AllVisitableCustomersModalFrameSubComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12499640",
  null
  
)

export default component.exports